import BaseButton from "./BaseButton";
import React from "react";

const ErrorButton = (props) => {
  if (!props.text || !props.onClick) {
    return null;
  }

  return <BaseButton {...props} bgColor="error" />;
};

export default ErrorButton;
